import { httpClient } from "./httpClient";

const base = "/api/menus";

export const obtenerMenu = () => httpClient.get(base);
export const listarAdmin = () => httpClient.get(`${base}/admin`);
export const actualizarOrden = (items) => httpClient.put(`${base}/orden`, { items });

const menuService = {
  obtener: obtenerMenu,
  listarAdmin,
  actualizarOrden,
};

export default menuService;
